import {
    assignReasonsConstantsFulfilledConstants,
    assignReasonsConstantsRejectedConstants,
    assignReasonsConstantsPendingConstants
} from '../actions';

const initialState = {
    data: {
        total: 0,
        items: []
    },
    error: ''
};

export default function (state = initialState, action) {
    switch (action.type) {

        case assignReasonsConstantsPendingConstants.ASSIGN_REASONS:
            return {
                ...state,
            };

        case assignReasonsConstantsFulfilledConstants.ASSIGN_REASONS:
            const { data } = action.payload;
            return {
                ...state,
                data: {
                    total: data.total,
                    items: data.items
                },
            };

        case assignReasonsConstantsRejectedConstants.ASSIGN_REASONS:
            const error = action.payload;

            return {
                ...state,
                error: error.response ? `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}` :
                    error.message
            };
        default:
            return state;
    }
}
